// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Components
import { UserListComponent } from './components/user-list/user-list.component';
import { UserEditComponent } from './components/user-edit/user-edit.component';

// Modules
import { CoreModule } from '../../core.module';
import { SharedModule } from '../../shared';
import { UserRoutingModule } from './user-routing.module';

@NgModule({
	declarations: [UserListComponent, UserEditComponent],
	imports: [CommonModule, CoreModule, SharedModule, UserRoutingModule],
	exports: [],
})
export class UsersModule {}
